import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MessagesService } from 'src/app/system/services/message.service';
import { TYPE_TOAST } from '../enums/ToastsEnums';
import { LoadingService } from './../../services/loading.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private static sessionExpired = false;
  constructor(
    private MessageService: MessagesService,
    private LoadingService: LoadingService,
    private Router: Router
  ) { }

  static resetSessionExpired() {
      ErrorInterceptor.sessionExpired = false;
    }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return <any>next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.LoadingService.Hide();

        console.log("************************ERROR************************");
        console.log(error);
        console.log("************************ERROR************************");

        const isTokenExpired =
          error.status === 401 &&
          (
            error?.error?.code === 'token_not_valid' ||
            error?.error?.detail?.toLowerCase().includes('token')
          );

        if (isTokenExpired) {
          if (!ErrorInterceptor.sessionExpired) {
            ErrorInterceptor.sessionExpired = true;

            localStorage.clear();
            this.Router.navigateByUrl('/login');

            this.MessageService.ShowErrorDialog(
              'Tu sesión ha vencido, vuelve a iniciar sesión'
            );
          }

          return throwError(() => error);
        }
        let msj = error?.error?.message ? error?.error?.message + ' (' + error?.error?.data + ')' : error?.error?.detail ? error?.error?.detail : "Ocurrió un error, favor de ponerse en contacto con soporte técnico.";

        if (msj === "Ocurrió un error, favor de ponerse en contacto con soporte técnico.") {
          this.MessageService.ShowErrorDialog(msj);
        } else if (error.status == 500) {
          this.MessageService.ShowErrorDialog(msj);
        } else if (error.status == 401) {
          localStorage.clear();

          this.Router.navigateByUrl("/login");
          this.MessageService.ShowErrorDialog(msj);
        } else if (error.status != 500) {
          this.MessageService.ShowMessage(TYPE_TOAST.ERROR, "Error", msj)
        } else {
          this.MessageService.ShowErrorDialog(msj);
        }

        return throwError(() => new Error(msj || "Sucedió un error con el servidor."));
      })
    );
  }
}
